import React from 'react';
import { Slide } from 'react-slideshow-image';

import { Link } from 'react-router-dom';

import 'react-slideshow-image/dist/styles.css'
import './PhotoSlider.css';
import { DEFAULT_PROFILE_IMAGE } from '../../../../util/ModelPhotos';

const PreviewSlider = ({ 
    col = 3,
    images = [],
    name = '',
    city = '',
    link = '',
    onImageClick,
    featured = false,
    showFeaturedBadge = true,
    showFeaturedBorder = true
}) => {

    const buttonStyle = {
        width: "30px",
        background: 'none',
        border: '0px',
        position:'absolute',
        left:0,
        top:'50%',
        opacity:'0'
    };

    const properties = {
        prevArrow: <button style={{ ...buttonStyle, 'transform':'rotateZ(180deg)' }}><svg width="15" height="15" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path></svg></button>,
        nextArrow: <button style={{ ...buttonStyle, 'left':'calc(100% - 30px)' }}><svg width="15" height="15" viewBox="0 0 24 24"><path d="M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z"></path></svg></button>,
        autoplay: false,
        transitionDuration: 200
    }

    const slideImages = Array.isArray(images) ? images.filter(Boolean) : [];
    const displayImages = slideImages.length ? slideImages : [DEFAULT_PROFILE_IMAGE];

    return (
        <div className={`${col === 1 ? "preview col1" : (col === 4 ? "preview col4" : "preview col3")}${featured ? ' preview-featured' : ''}`}>
            <Slide {...properties}>
                {displayImages.map((image, index) => (
                    <div className="each-slide-effect" key={`${image}-${index}`}>
                        {link ? (
                            <Link
                                to={link}
                                className="preview-photo-link"
                                aria-label={`View ${name || 'model'} profile photo ${index + 1}`}
                            >
                                <div style={{backgroundImage: `url("${image}")`}}></div>
                            </Link>
                        ) : onImageClick ? (
                            <button
                                type="button"
                                className="preview-photo-button"
                                onClick={() => onImageClick(index)}
                                aria-label={`View ${name || 'model'} photo ${index + 1} full screen`}
                            >
                                <div style={{backgroundImage: `url("${image}")`}}></div>
                            </button>
                        ) : (
                            <div style={{backgroundImage: `url("${image}")`}}></div>
                        )}
                        {featured && showFeaturedBorder && <div className="preview-featured-overlay">
                            {showFeaturedBadge && <>
                                <span className="preview-featured-label">SADIDA FEATURED</span>
                                <svg className="preview-featured-crown" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                                    <path d="m3 7 4.5 3L12 4l4.5 6L21 7l-1.5 11h-15L3 7Z" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M5 21h14" strokeLinecap="round" />
                                </svg>
                            </>}
                        </div>}
                    </div>
                ))}
            </Slide>
            {
                name !== '' && city !== '' ?
                    <>
                        <div className="preview-info">
                            <Link to={link}>
                                <span>
                                    <div className="ps-name">
                                        {name}
                                    </div>
                                    <div className="ps-city">
                                        {city}
                                    </div>
                                </span>
                            </Link>
                        </div>
                    </>  : ''
            }
        </div>
    );
};

export default PreviewSlider;